import React, { useEffect, useRef, useState } from "react";
import { CalendarDays } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/i18n/LanguageContext";
import { UpcomingTasks } from "@/components/SmartWidgets";
import { L } from "@/components/ideaos/shared";
import { useSinglePanel } from "@/lib/portalPanels";

/** Floating "Prossimi task" button next to the bulb: badge with count, small panel with the upcoming tasks. */
export function TasksBulb() {
  const { user } = useAuth();
  const { lang } = useLang();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const closePanel = React.useCallback(() => setOpen(false), []);
  useSinglePanel("tasks", open, closePanel);
  useEffect(() => {
    if (!user) return;
    const load = () => api.get("/home").then(({ data }) => setItems(data.upcoming || [])).catch(() => {});
    load(); const id = setInterval(load, 120000); return () => clearInterval(id);
  }, [user]);
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    const onDown = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    document.addEventListener("keydown", onKey); document.addEventListener("pointerdown", onDown);
    return () => { document.removeEventListener("keydown", onKey); document.removeEventListener("pointerdown", onDown); };
  }, [open]);
  if (!user) return null;
  return (
    <div ref={ref} className="relative shrink-0">
      <button type="button" onClick={() => setOpen((v) => !v)} aria-expanded={open} aria-label={L(lang, "Prossimi task", "Upcoming tasks")} title={L(lang, "Prossimi task", "Upcoming tasks")} data-testid="portal-tasks"
        className="relative inline-flex h-11 w-11 items-center justify-center rounded-full bg-white/92 ring-1 ring-slate-200/80 backdrop-blur-md text-[#0b0f1a] transition-colors hover:bg-[#f4f6fa] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#7c3aed]">
        <CalendarDays size={18} />
        {items.length > 0 && <span className="absolute -right-0.5 -top-0.5 inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-[#0b0f1a] px-1 text-[10px] font-bold text-white ring-2 ring-white" data-testid="portal-tasks-badge">{items.length}</span>}
      </button>
      {open && (
        <div role="dialog" aria-label={L(lang, "Prossimi task", "Upcoming tasks")} data-testid="tasks-panel" className="absolute bottom-14 left-1/2 w-[min(22rem,calc(100vw-1.5rem))] -translate-x-1/2 rounded-[1.5rem] bg-white/95 p-1 ring-1 ring-slate-200/80 backdrop-blur-md shadow-[0_24px_60px_-28px_rgba(11,15,26,0.4)] max-md:fixed max-md:bottom-[calc(var(--portal-bottom)+3.75rem)] max-md:left-1/2 max-md:-translate-x-1/2">
          <UpcomingTasks items={items} />
        </div>
      )}
    </div>
  );
}
